import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import Decimal from 'decimal.js';
import { StagesValueType } from '~/models';
export const stagesTextsPath = 'billing.stages';
export const getDisabledReasonTooltip = (param)=>{
    let { texts, disabledReason } = param;
    if (!disabledReason) return undefined;
    return ({
        existingServiceInAgreement: texts.cannotModify()
    })[disabledReason];
};
export const calculateStages = (param)=>{
    let { length, totalRate, valueType } = param;
    const total = isValueTypeDollars(valueType) ? totalRate : new Decimal(100);
    const baseValue = total.div(length).toDecimalPlaces(2);
    const stages = Array(length).fill(undefined).map((_, index)=>({
            stageNumber: index + 1,
            value: new Decimal(baseValue)
        }));
    setFinalStage(stages, valueType, totalRate);
    return stages;
};
export const addStage = (stages)=>{
    const insertIndex = stages.length - 1;
    return [
        ...stages.slice(0, insertIndex),
        {
            stageNumber: insertIndex + 1,
            value: new Decimal(0)
        },
        ...stages.slice(insertIndex).map((stage)=>_object_spread_props(_object_spread({}, stage), {
                stageNumber: stage.stageNumber + 1
            }))
    ];
};
export const removeStage = (stages, indexToRemove)=>{
    const removedStage = stages[indexToRemove];
    const newStages = stages.filter((_, index)=>index !== indexToRemove).map((stage, index)=>_object_spread_props(_object_spread({}, stage), {
            stageNumber: index + 1
        }));
    const lastStageIndex = newStages.length - 1;
    newStages[lastStageIndex] = _object_spread_props(_object_spread({}, newStages[lastStageIndex]), {
        value: newStages[lastStageIndex].value.plus(removedStage.value)
    });
    return newStages;
};
export const isValueTypeDollars = (valueType)=>valueType === StagesValueType.Amount;
export const isValueTypePercent = (valueType)=>valueType === StagesValueType.Percent;
export const valueTypeTextMap = {
    [StagesValueType.Percent]: '%',
    [StagesValueType.Amount]: '$'
};
export const setFinalStage = (stages, valueType, totalRate)=>{
    const total = isValueTypeDollars(valueType) ? totalRate : new Decimal(100);
    const stagesSum = stages.slice(0, -1).reduce((acc, stage)=>acc.plus(stage.value), new Decimal(0));
    const lastStageValue = total.minus(stagesSum);
    if (stagesSum.gt(total)) return;
    stages[stages.length - 1] = _object_spread_props(_object_spread({}, stages[stages.length - 1]), {
        value: lastStageValue.toDecimalPlaces(2)
    });
};
export const getHelperText = (param)=>{
    let { stage, isLast, valueType, totalRate, totalSumExceedsRate, texts } = param;
    if (isValueTypePercent(valueType) && stage.value.gte(100)) return texts.validation.exceedsPercent();
    if (isValueTypeDollars(valueType) && stage.value.gt(totalRate)) return texts.validation.exceedsServiceTotal();
    if (isValueTypePercent(valueType) && !isLast && totalSumExceedsRate) return texts.validation.exceedsPercent();
    if (isValueTypeDollars(valueType) && !isLast && totalSumExceedsRate) return texts.validation.exceedsServiceTotal();
    if (isLast && stage.value.eq(0)) return texts.validation.lastPaymentCannotBeEmpty();
    if (stage.value.eq(0)) return texts.validation.insertAmount();
    return undefined;
};
